// Live password strength bar — shared by change-password, forced-change
// and reset flows. Pure scoring, no deps.
import React from 'react';

export const scorePassword = (pw) => {
  if (!pw || pw.length < 8) return 0;
  let s = 1;
  if (pw.length >= 12) s++;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) s++;
  if (/\d/.test(pw)) s++;
  if (/[^A-Za-z0-9]/.test(pw)) s++;
  return Math.min(4, s);
};

const LABELS = ['Too short (min 8)', 'Weak', 'Okay', 'Good', 'Strong'];
const COLORS = ['bg-red-500', 'bg-orange-400', 'bg-amber-400', 'bg-lime-500', 'bg-emerald-500'];
const TEXT = ['text-red-500', 'text-orange-500', 'text-amber-500', 'text-lime-600', 'text-emerald-600'];

export const PasswordStrengthMeter = ({ password }) => {
  if (!password) return null;
  const score = scorePassword(password);
  return (
    <div className="mt-1.5" data-testid="password-strength-meter">
      <div className="flex gap-1">
        {[0, 1, 2, 3].map((i) => (
          <div key={i}
            className={`h-1 flex-1 rounded-full transition-colors ${score > i ? COLORS[score] : 'bg-slate-200 dark:bg-white/10'}`} />
        ))}
      </div>
      <p className={`text-[10px] font-semibold mt-0.5 ${TEXT[score]}`} data-testid="password-strength-label">
        {LABELS[score]}
      </p>
    </div>
  );
};
